import $axios from "@/api";
import helper from "@/assets/js/helper.js";

const state = () => ({
    data: {
        group: [],
        penjualan: [],
        retur_penjualan: [],
    },
    filter: {
        form: false,
        modal: false,
        requested: false,

        start_date: helper.methods.dateTime('ymd'),
        end_date: helper.methods.dateTime('ymd'),

        group_by: 'Depo',

        id_perusahaan: [],
        id_depo: [],
        id_mitra: [],
        id_brand: [],
        id_barang: [],
        id_gudang: [],
        id_salesman: [],
        id_principal: [],
    },
})

const mutations = {
}

const actions = {
    triggerFilter({ state }) {
        let is_modal = !state.filter.modal;
        let navigator = { true: 'form', false: 'modal' }
        state.filter[navigator[is_modal]] = is_modal
        setTimeout(() => {
            state.filter[navigator[!is_modal]] = is_modal
        }, 100)
    },
    fetchData({ state }, payload = null) {
        state.filter.requested = true
        return new Promise((resolve) => {
            let filter = payload === null ? { ...state.filter } : payload
            delete filter.form;
            delete filter.modal;
            delete filter.requested;
            $axios.get(`monitoring/retur`, { params: filter }).then((res) => {
                state.data = res.data
                resolve(res.data)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
